import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserPointsRedemptionHistory } from '@/shared/model/user-points-redemption-history.model';

const baseApiUrl = 'api/user-points-redemption-histories';
const baseSearchApiUrl = 'api/_search/user-points-redemption-histories?query=';

export default class UserPointsRedemptionHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserPointsRedemptionHistory> {
    return new Promise<IUserPointsRedemptionHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserPointsRedemptionHistory): Promise<IUserPointsRedemptionHistory> {
    return new Promise<IUserPointsRedemptionHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserPointsRedemptionHistory): Promise<IUserPointsRedemptionHistory> {
    return new Promise<IUserPointsRedemptionHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
